import React from "react";

import icon_directory_pink from "./../../../sources/icons/icon-directory-pink.svg";

export default function Malware () {
    return (
        <>
            <h3 className="span-blue" id="malware">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> Malware.<span className="span-pink cursor">_</span>
                </span>
            </h3>
            
            <p>
                Diferentes tipos de <span className="span-pink">ataques</span>, cuyo <span className="span-white">objetivo</span> es <span className="span-pink">infiltrarse</span> en un <span className="span-blue">sistema</span> o <span className="span-blue">red</span> para <span className="span-blue">causar daño, robar información, espiar</span> o <span className="span-blue">interrumpir
                operaciones.</span>
            </p>
            
            <p>
                <b className="span-yellow">Herramientas:</b> <a href="#" className="span-blue">Msfvenom</a>, <a href="#"
                    className="span-blue">Revershells.</a>
            </p>
        </>
    );
}